import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import moment from 'moment'
import './index.scss'
import UserCard from '../../../components/Settings/UserCard'
import UserFilter from '../../../components/Settings/UserFilter'
import CloudFlyerAPI from '../../../api/CloudFlyerAPI'
import { Table, Tag, Switch, Icon, message } from 'antd'
import { receiveError } from '../../../api/http'
import LoadingSpinner from '../../../components/Shared/LoadingSpinner'
import { fetchRoles } from '../../../actions/roles'
import InviteUser from '../InviteUser'

class UserList extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            initialUsers: [],
            users: [],
            roles: [],
            loading: false,
            filter: {
                search: '',
                select: '',
            },
        }

        const { auth, history } = this.props

        this.columns = [
            { title: 'Full Name', dataIndex: 'fullname', key: 'fullname' },
            {
                title: 'Role',
                dataIndex: 'role',
                key: 'role',
                render: d => (
                    <Tag size="large" color="blue" key={d}>
                        {d}
                    </Tag>
                ),
            },
            {
                title: 'Email',
                dataIndex: 'email',
                key: 'email',
                render: email => <a href={`mailto:${email}`}>{email}</a>,
            },
            {
                title: 'Last Active',
                dataIndex: 'lastActive',
                key: 'lastActive',
                render: date => moment(date).format('MM/DD/YYYY'),
            },
            {
                title: 'Active?',
                dataIndex: 'active',
                key: 'active',
                render: (text, user, index) => {
                    const userData = this.state.users.filter(
                        u => u.email === user.email
                    )[0]
                    return (
                        <div onClick={e => e.stopPropagation()}>
                            <Switch
                                checked={user.active}
                                disabled={
                                    !(
                                        auth.user.id !== userData.id &&
                                        (auth.user.role.title === 'Owner' ||
                                            (auth.user.role.title === 'Admin' &&
                                                userData.role.title === 'User'))
                                    )
                                }
                                onChange={() =>
                                    this.toggleUserActive(
                                        userData.id,
                                        !user.active
                                    )
                                }
                            />
                        </div>
                    )
                },
            },
            {
                title: '',
                dataIndex: '',
                key: 'settings',
                render: (text, user, index) => (
                    <a
                        onClick={() =>
                            history.push(
                                `/users/${this.findIdByEmail(
                                    this.state.users,
                                    user.email
                                )}`
                            )
                        }>
                        <Icon type="setting" style={{ fontSize: '1.3rem' }} />
                    </a>
                ),
            },
        ]

        this.filterUserList = this.filterUserList.bind(this)
        this.toggleUserActive = this.toggleUserActive.bind(this)
    }

    toDateSource(data) {
        return data.map(d => {
            return {
                fullname: `${d.first_name} ${d.last_name}`,
                email: d.email,
                role: d.role.title,
                lastActive: d.activation_date,
                active: d.active,
            }
        })
    }

    findIdByEmail(users, email) {
        return users.filter(user => user.email === email)[0].id
    }

    componentDidMount() {
        this.props.fetchRoles()
        this.setState({
            loading: true,
        })
        CloudFlyerAPI.user_account
            .fetchAll()
            .then(({ data }) => {
                this.setState({
                    initialUsers: data,
                    users: data,
                    loading: false,
                })
            })
            .catch(err => {
                const msg = receiveError(null, err).message
                message.error(msg)
            })
    }

    componentWillReceiveProps({ roles }) {
        if (roles.error) {
            message.error(roles.error)
        } else if (roles.items !== null) {
            this.setState({
                roles: roles.items,
            })
        }
    }

    filterUserList({ target }, name) {
        const { value } = target
        this.setState(
            {
                filter: { ...this.state.filter, [name]: value },
            },
            args => {
                const { filter, initialUsers } = this.state
                let filteredUsers = [...initialUsers]
                if (filter.search) {
                    filteredUsers = filteredUsers.filter(
                        ({ first_name, last_name }) =>
                            first_name
                                .toLowerCase()
                                .includes(filter.search.toLowerCase()) ||
                            last_name
                                .toLowerCase()
                                .includes(filter.search.toLowerCase())
                    )
                }
                if (filter.select) {
                    filteredUsers = filteredUsers.filter(
                        ({ role }) => role.title === filter.select
                    )
                }
                this.setState({ users: filteredUsers })
            }
        )
    }

    toggleUserActive(userId, active) {
        ;(active
            ? CloudFlyerAPI.user_account.activate
            : CloudFlyerAPI.user_account.deactivate)(userId)
            .then(() => {
                const users = this.state.users.map(user => {
                    if (user.id === userId) {
                        user = { ...user, active }
                    }
                    return user
                })
                this.setState({
                    users,
                })
                const action = active ? 'activated' : 'deactivated'
                message.success('User successfully ' + action)
            })
            .catch(this.handleError)
    }

    handleError(err) {
        const msg = receiveError(null, err).message
        message.error(msg)
    }

    render() {
        const { users, filter, roles, loading } = this.state
        const { history } = this.props
        if (loading) {
            return <LoadingSpinner />
        }
        return (
            <div className="user-list">
                <InviteUser />
                <UserFilter
                    {...filter}
                    roles={roles}
                    filterUserList={this.filterUserList}
                />
                <div className="users-table">
                    <Table
                        dataSource={this.toDateSource(users)}
                        columns={this.columns}
                        rowKey={user => user.email}
                    />
                </div>
            </div>
        )
    }
}

function mapStateToProps({ auth, roles }) {
    return { auth, roles }
}

function mapDispatchToProps(dispatch) {
    return {
        fetchRoles: bindActionCreators(fetchRoles, dispatch),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserList)
